module.exports = __webpack_public_path__ + "static/media/logo.5b4fde2a.svg";